import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, RouterStateSnapshot } from '@angular/router';
import { filter, map, Observable, take } from 'rxjs';
import { Router } from '@angular/router';
import { IUser, Roles } from '@cod-monorepo/interfaces';
import { Store } from '@ngxs/store';
import { UserState } from '../../user-management/state/user-management.state';

@Injectable({ providedIn: 'root' })
export class ReportingGuard {
    user$: Observable<IUser | undefined> = inject(Store).select(UserState.user);
    constructor(private router: Router) {}

    canLoad(): Observable<boolean> {
        return this.user$.pipe(
            filter(user => !!user),
            take(1),
            map(user => {
                const allowedRoles = [Roles.ADMIN, Roles.REPORTING];
                if (allowedRoles.some(role => user.roles?.includes(role))) {
                    return true;
                } else {
                    void this.router.navigate(['/auth/unauthorized']);
                    return false;
                }
            })
        );
    }
}

export const canActivateReporting: CanActivateFn = (
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
    adminGuard = inject(ReportingGuard)
) => adminGuard.canLoad();
